import { createReducer } from "@reduxjs/toolkit";
import AC from "../Actions";
const initialStateSidebar = {
  sidebarShow: false,
};

const showAndHideSidebar = createReducer(initialStateSidebar, (builder) => {
  builder.addCase(AC.set, (state, action) => {
    state.sidebarShow = action.payload;
  });
});

const index = {
  showAndHide: showAndHideSidebar,
};
export default index;
